// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"5af360c1","453":"e91ed3b1","457":"92ee5e3a","676":"8663fb62","719":"1a866e5f","723":"17cfb0ab","826":"46bcd165","843":"d4194763","916":"39a128c5"}[chunkId] + ".chunk.js";
};